// Lightweight SEO helpers for the SPA: keep a single canonical <link> and a single
// <meta name="description"> in <head>, updated imperatively per route/entity.
export const CANONICAL_HOST = "https://livingwisdomexplorer.org";

export const DEFAULT_DESCRIPTION =
  "Living Wisdom Explorer — explore 5,000 years of ancient Indian philosophy as one interconnected knowledge graph. Search concepts, schools, texts and thinkers across Vedānta, Sāṃkhya, Yoga, Buddhism, Jainism and Nyāya.";

export function setCanonical(href) {
  if (typeof document === "undefined") return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export function setDescription(text) {
  if (typeof document === "undefined") return;
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", text || DEFAULT_DESCRIPTION);
}

// Build the canonical URL for a given router location, folding query variants so
// Google consolidates duplicates onto one URL per page.
export function canonicalFor(location) {
  const path = location.pathname || "/";
  const params = new URLSearchParams(location.search || "");
  const node = params.get("node");
  if (path === "/explore" && node) {
    return `${CANONICAL_HOST}/explore?node=${encodeURIComponent(node)}`;
  }
  return `${CANONICAL_HOST}${path}`;
}
